import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ChevronDownSmall = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M11.75 6.43701L8.17667 10.01C8.15348 10.0332 8.12594 10.0517 8.09563 10.0642C8.06531 10.0768 8.03282 10.0833 8 10.0833C7.96718 10.0833 7.93469 10.0768 7.90437 10.0642C7.87406 10.0517 7.84652 10.0332 7.82333 10.01L4.25 6.43701"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
